import React from 'react'
import ProgressCard from './ProgressCard'

const ProgressTrackerSection = () => {
  return (
    <div style={{marginBottom:"4rem", padding: "50px 20px"}} className='container '>
      <div className='progress-tracker-div'>
        <h4 className='text-uppercase Ethnocentric'>Our process to deliver your package</h4>
      </div>
        <div  className='d-flex justify-content-center'>
          <span style={{marginTop:'35px'}} className='vertical-design'></span>
          <div className='progress-card-div'>
              <ProgressCard index={1} description={`We collect your shipment and ensure all documents are accurately prepared for seamless processing.`} title={"Pickup & Documentation"}/>
              <ProgressCard index={2} description={`Our experts handle customs, inspections, and duties, ensuring full compliance with local regulations.`} title={"Customs Clearance & Handling"}/>
              <ProgressCard index={3} description={`customs clearance for smooth delivery.`} title={"Final Delivery"}/>
          </div>
        </div>
    </div>
  )
}

export default ProgressTrackerSection